import { type Link, NavLink } from 'react-router-dom'

const LEGACY_URL = import.meta.env.VITE_LEGACY_URL

type NavLinkItem = {
  label: string
  href?: string
  to?: string
  value: string
  component?: typeof Link | typeof NavLink
  visibleTo?: ('admin' | 'provider')[]
  platforms?: ('cat' | 'perkins')[]
}

export const links: NavLinkItem[] = [
  {
    label: 'Search',
    component: NavLink,
    to: '/search',
    value: 'search',
  },
  {
    label: 'Collections',
    href: `${LEGACY_URL}/Collections.aspx`,
    value: 'collections',
  },
  {
    label: 'Notifications',
    href: `${LEGACY_URL}/Notifications.aspx`,
    value: 'notifications',
  },
  {
    label: "What's New",
    component: NavLink,
    to: '/WhatsNew',
    value: 'whatsnew',
  },
  {
    label: 'Add Media',
    href: `${LEGACY_URL}/AddMedia/Index`,
    value: 'addmedia',
    visibleTo: ['admin', 'provider'],
  },
  {
    label: 'Bulk Edit',
    component: NavLink,
    to: '/bulk-edit',
    value: 'bulk-edit',
    visibleTo: [], //empty on purpose, only visible if on page
  },
  {
    label: 'Delegate Rights',
    href: `${LEGACY_URL}/DelegateRightsDashboard.aspx`,
    value: 'delegaterights',
    visibleTo: ['admin', 'provider'],
  },
  {
    label: 'Administration',
    href: `${LEGACY_URL}/Administration.aspx`,
    value: 'administration',
    visibleTo: ['admin', 'provider'],
  },
  {
    label: 'Create Media Number',
    href: `${LEGACY_URL}/Reservations/Index`,
    value: 'createmedianumber',
    visibleTo: ['admin', 'provider'],
    platforms: ['cat'],
  },
  {
    label: 'Media Management',
    component: NavLink,
    to: '/mediamanagement',
    value: 'mediamanagement',
    visibleTo: ['admin', 'provider'],
  },
  {
    label: 'Provider Management',
    component: NavLink,
    to: '/providermanagement',
    value: 'providermanagement',
    visibleTo: ['admin'],
  },
  {
    label: 'Help',
    href: `${LEGACY_URL}/Help.aspx`,
    value: 'help',
  },
]
